import { Component, input, output } from "@angular/core";
import {
  PageToolbarItemType,
  PageTooolbarItem
} from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";

@Component({
  selector: "snt-page-toolbar-daterange",
  template: "",
  providers: [
    {
      provide: PageToolbarItemComponent,
      useExisting: PageToolbarDateRangeComponent
    }
  ],
  standalone: false
})
export class PageToolbarDateRangeComponent implements PageTooolbarItem {
  type: PageToolbarItemType = "daterange";

  title = input<string | undefined>(undefined);

  range = output<[Date, Date] | null>();

  presets = input<Record<string, [Date, Date]> | undefined>(undefined);
}
